import fetch from '@/util/fetch';
import {authUrl, baseUrl} from '@/global';

export const login = (params) => fetch.post(`${authUrl}/oauth/token`, params.payload,
    {
      params: {
        grant_type: 'password',
        client_id: 'web',
        client_secret: '123456',
        validCode: 'hbcs',
        ...params,
      },
    },
);

/**
 * 获取用户信息
 */
export const getUserInfo = () => fetch(`${baseUrl}/user-center/user/info`);
/**
 * 获取用户信息
 */
export const querySmsSysConfig = () => fetch(`${baseUrl}/business-corp-api/corporation/querySmsSysconfig`);

/**
 * 修改用户信息
 */
export const editUserInfo = (data) => fetch.put(`${baseUrl}/user-center/user/edit`, data);

/**
 * 修改密码
 */
export const retrievePwd = (data) => fetch.post(`${baseUrl}/user-center/user/retrievePwd`, data);

/**
 * 修改手机号码
 */
export const updateMobile = (params) => fetch.put(`${baseUrl}/user-center/user/updateMobile`, params.payload, {params});

/**
 * 修改手机号验证
 */
export const updateMobileVerify = (params) => fetch(`${baseUrl}/user-center/user/updateMobileVerify`, {params: {identityType: 2, ...params}});

/**
 * 修改密码身份验证
 */
export const updatePasswordVerify = (params) => fetch(`${baseUrl}/user-center/user/verify`, {params});

/**
 * 图形验证码发送接口
 */
export const captchaImageUrl = `${baseUrl}/captcha/image?deviceId=`;

/**
 * 短信验证码发送接口
 */
export const captchaSms = (params) => fetch(`${baseUrl}/captcha/sms`, {params});

/**
 * 图片文件上传接口
 */
// export const imgUpload = (params) => fetch.post(`${baseUrl}/file-center/file/uploadAvatar`, params);
export const imgUpload = (params) => fetch.post(`${baseUrl}/zuul/file-center/file/uploadImg`, params);

/**
 * 设置默认企业
 */
export const setDefaultCorp = (params) => fetch.put(`${baseUrl}/user-center/user/defaultCorp/${params.corpId}`);

/**
 * 忘记密码
 */
export const forgotPwd = (params) => fetch.post(`${baseUrl}/user-center/user/forgetPwd`, params.payload, {params});
